import styled from 'styled-components';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  margin: 0 0 1rem 0;
`;

export const InputContainer = styled.div`
  margin-bottom: 1rem;
`;
